import { create } from 'zustand';
import type {
  GridFilterModel,
  GridPaginationModel,
  GridSortModel,
} from '@mui/x-data-grid-premium';

interface GridPageState {
  paginationModel?: GridPaginationModel;
  sortModel?: GridSortModel;
  filterModel?: GridFilterModel;
  custom?: Record<string, unknown>;
}

interface GridStateStore {
  pages: Record<string, GridPageState>;
  getPageState: (pageId: string) => GridPageState | undefined;
  setPageState: (pageId: string, state: Partial<GridPageState>) => void;
  setCustom: (pageId: string, key: string, value: unknown) => void;
  clearPage: (pageId: string) => void;
  clearAll: () => void;
}

export const useGridStateStore = create<GridStateStore>()((set, get) => ({
  pages: {},

  getPageState: (pageId) => get().pages[pageId],

  setPageState: (pageId, patch) =>
    set((s) => ({
      pages: {
        ...s.pages,
        [pageId]: { ...s.pages[pageId], ...patch },
      },
    })),

  setCustom: (pageId, key, value) =>
    set((s) => {
      const current = s.pages[pageId] ?? {};
      return {
        pages: {
          ...s.pages,
          [pageId]: {
            ...current,
            custom: { ...current.custom, [key]: value },
          },
        },
      };
    }),

  clearPage: (pageId) =>
    set((s) => {
      const { [pageId]: _, ...rest } = s.pages;
      return { pages: rest };
    }),

  clearAll: () => set({ pages: {} }),
}));
